import React from 'react';
import {BaseInputProps} from '../..';

import {useFormContext} from 'react-hook-form';
import {NestedKeys} from 'shared/types/key-manipulation';

import {Container, Label, Button, Placeholder, Row} from './styles';

export interface InputButtonProps<T = any> extends BaseInputProps {
  onClick?: () => void;
  placeholder?: string;
  gridColumn?: number;
  objectName?: NestedKeys<T>;
  formatValue?: (value: T) => void;
  name: NestedKeys<T>;
  icon?: (value: any) => void;
}

const InputButton: React.FC<InputButtonProps> = ({
  label,
  onClick,
  placeholder,
  gridColumn,
  name,
  border,
  formatValue,
  icon,
  objectName,
  disabled,
}) => {
  const {getValues} = useFormContext();
  const value = getValues(name);
  const objectValue = objectName ? getValues(objectName) : getValues();

  return (
    <Container
      {...{onClick: disabled ? undefined : onClick, gridColumn, border}}>
      <Label>{label}</Label>
      <Row>
        {objectValue && icon && icon(objectValue)}
        <Button value={value}>
          {(value || formatValue) && (
            <p>{formatValue ? formatValue(objectValue) : value}</p>
          )}
          {!value && (!formatValue || !objectValue) && (
            <Placeholder>{placeholder}</Placeholder>
          )}
        </Button>
      </Row>
    </Container>
  );
};

export default InputButton;
